import { Routes, Route, Navigate } from 'react-router-dom';
import AdminPage from './admin';

/**
 * Routes for the Kit Staging admin area (Dashboard / Staging Areas / Dekit
 * Areas). Mounted under `/admin/kit-staging/*` and gated by `Shop Managers`
 * in PrivateRoutes. The admin surface is a single tabbed page, so all paths
 * resolve to it.
 */
const AdminRoutes = () => {
	return (
		<Routes>
			<Route path="/" element={<AdminPage />} />
			<Route path="*" element={<Navigate to="." replace />} />
		</Routes>
	);
};

export default AdminRoutes;
